module.exports = __webpack_public_path__ + "static/media/side-bg.95ca3954.jpg";